import {
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonSkeletonText,
} from "@ionic/react";

export const Skeleton = () => {
  return (
    <IonCard
      className="trade-card ion-no-padding ion-no-margin ion-no-border"
      style={{
        borderRadius: "0px",
        marginBottom: "10px",
        background: "#0d1b2a",
        borderBottom: "1px solid #1b2a3a",
      }}
    >
      <IonCardContent className="trade-content" style={{ padding: "12px" }}>
        <IonGrid className="header-grid ion-no-padding">
          <IonRow className="header-row">
            <IonCol size="3">
              <div className="time-container">
                <IonText className="label">
                  <p
                    style={{
                      fontSize: "var(--one-font-size-7)",
                      marginBottom: 5,
                    }}
                  >
                    <IonSkeletonText
                      animated
                      style={{ width: "60%", height: "10px" }}
                    />
                  </p>
                </IonText>
                <IonText className="value">
                  <p style={{ fontSize: "var(--one-font-size-7)" }}>
                    <IonSkeletonText
                      animated
                      style={{ width: "90%", height: "14px" }}
                    />
                  </p>
                </IonText>
              </div>
            </IonCol>
            <IonCol size="9">
              <IonText className="block-title">
                <p style={{ fontSize: "var(--one-font-size-7)" }}>
                  <IonSkeletonText
                    animated
                    style={{ width: "70%", height: "16px" }}
                  />
                </p>
              </IonText>
            </IonCol>
          </IonRow>

          <IonRow style={{ marginTop: "16px" }}>
            {[1, 2, 3, 4, 5].map((i) => (
              <IonCol key={i}>
                <IonSkeletonText
                  animated
                  style={{ width: "40%", height: "10px" }}
                />
              </IonCol>
            ))}
          </IonRow>

          <IonRow style={{ marginTop: "8px" }}>
            {[1, 2, 3, 4, 5].map((i) => (
              <IonCol key={i}>
                <IonSkeletonText
                  animated
                  style={{ width: "60%", height: "14px" }}
                />
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};
